import { SectionEyebrow } from "@/components/ui/SectionEyebrow";
import { whmcs } from "@/config/whmcs";

const steps = [
  {
    n: "01",
    title: "Choose Your Solution",
    body: "Select VPS, dedicated server, cloud, email or a security solution.",
  },
  {
    n: "02",
    title: "Configure Your Product",
    body: "Choose the available resources, billing cycle and optional services through the secure billing platform.",
  },
  {
    n: "03",
    title: "Create Your Account",
    body: "Enter your business details and complete the checkout process.",
  },
  {
    n: "04",
    title: "Begin Deployment",
    body: "Receive your order information and continue from your client account.",
  },
];

export function PurchaseProcess() {
  return (
    <section className="mx-auto max-w-7xl px-5 py-20 lg:px-8">
      <div className="max-w-2xl">
        <SectionEyebrow>How It Works</SectionEyebrow>
        <h2 className="mt-5 font-display text-3xl font-semibold text-text-primary sm:text-4xl">
          From Selection to Deployment in a Few Simple Steps
        </h2>
      </div>

      <div className="mt-12 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
        {steps.map((s) => (
          <div key={s.n} className="relative rounded-card border border-border bg-navy-card p-6">
            <span className="font-display text-3xl font-semibold text-cyan/40">{s.n}</span>
            <h3 className="mt-4 font-display text-base font-semibold text-text-primary">
              {s.title}
            </h3>
            <p className="mt-2 text-sm leading-relaxed text-text-secondary">{s.body}</p>
          </div>
        ))}
      </div>

      <div className="mt-10 text-center">
        <a
          href={whmcs.storeUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="focus-ring inline-flex items-center gap-2 rounded-full bg-gradient-brand px-6 py-3 text-sm font-medium text-white transition hover:brightness-110"
        >
          Browse Product Catalogue
        </a>
      </div>
    </section>
  );
}
